import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Breadcrumb from "../common/Breadcrumb";
import {
  FaHome,
  FaFileInvoice,
  FaPlus,
  FaAddressBook,
  FaUsersCog,
  FaBoxes,
  FaBars,
  FaChevronLeft,
  FaSignOutAlt,
  FaUserCircle,
  FaPercentage,
  FaRupeeSign,
  FaClipboardList,
  FaWrench,
  FaShippingFast,
  FaFileAlt,
  FaExchangeAlt,
  FaCubes,
  FaMoneyBillWave,
} from "react-icons/fa";
import "./sidebar.css";

const NAV_ITEMS = [
  { label: "Home",              path: "/dashboard",         icon: FaHome,        roles: ["superadmin"] },
  { label: "Invoice Details",   path: "/invoiceGrid",       icon: FaFileInvoice, roles: ["admin", "superadmin"] },
  { label: "Create Invoice",    path: "/invoice",           icon: FaPlus,        roles: ["admin", "superadmin"] },
  { label: "Consignee Details", path: "/cdGrid",            icon: FaAddressBook, roles: ["superadmin"] },
  { label: "User Management",   path: "/users",             icon: FaUsersCog,    roles: ["superadmin"] },
  { label: "Product Mgmt",      path: "/productManagement", icon: FaBoxes,       roles: ["admin", "superadmin"] },
  { label: "GST Reports",        path: "/gstReports",         icon: FaPercentage,    roles: ["superadmin"] },
  { label: "Payment Tracker",    path: "/paymentTracker",     icon: FaRupeeSign,     roles: ["superadmin"] },
  { label: "Order Copy",         path: "/orderCopy",         icon: FaClipboardList, roles: ["admin", "superadmin"] },
  { label: "Quotations",         path: "/quotations",         icon: FaClipboardList, roles: ["admin", "superadmin"] },
  { label: "Job Orders",          path: "/jobOrders",          icon: FaWrench,        roles: ["admin", "superadmin"] },
  { label: "Dispatch Tracker",    path: "/dispatches",         icon: FaShippingFast,  roles: ["admin", "superadmin"] },
  { label: "Cust. Statement",     path: "/customerStatement",  icon: FaFileAlt,       roles: ["superadmin"] },
  { label: "Challan Register",    path: "/challans",           icon: FaExchangeAlt,   roles: ["admin", "superadmin"] },
  { label: "Raw Materials",       path: "/rawMaterials",       icon: FaCubes,          roles: ["admin", "superadmin"] },
  { label: "Expenses",            path: "/expenses",           icon: FaMoneyBillWave,  roles: ["admin", "superadmin"] },
];

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  const user = JSON.parse(sessionStorage.getItem("auth") || "null");

  useEffect(() => {
    document.body.classList.add("sb-ready");
    if (collapsed) {
      document.body.classList.add("sb-collapsed");
    } else {
      document.body.classList.remove("sb-collapsed");
    }
    return () => {
      document.body.classList.remove("sb-ready", "sb-collapsed");
    };
  }, [collapsed]);

  const handleLogout = () => {
    sessionStorage.removeItem("auth");
    navigate("/");
  };

  const visibleLinks = NAV_ITEMS.filter((item) => {
    if (!user?.role || !item.roles.includes(user.role)) return false;
    if (user.role === "superadmin") return true;
    // admin: if no allowedPages set, show all role-permitted items
    const allowedPages = Array.isArray(user.allowedPages) ? user.allowedPages : [];
    if (allowedPages.length === 0) return true;
    // derive pageKey from path (strip leading slash)
    const pageKey = item.path.replace(/^\//, "");
    return allowedPages.includes(pageKey);
  });

  return (
    <>
      {/* Fixed top header */}
      <header className="app-header">
        <div className="app-header__logo">
          <img src="/img/SSTLOGO.jpg" alt="SST Logo" className="app-header__logo-img" />
        </div>
        <div className="app-header__right">
          {user?.role && (
            <span className={`app-header__role ${user.role}`}>{user.role}</span>
          )}
          <div className="app-header__sep" />
          <button className="app-header__logout" onClick={handleLogout} title="Logout">
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </header>

      {/* Nav sidebar */}
      <aside className={`sidebar${collapsed ? " sidebar--collapsed" : ""}`}>
        <div className="sidebar__toggle-row">
          <button
            className="sidebar__toggle"
            onClick={() => setCollapsed((c) => !c)}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <FaBars /> : <FaChevronLeft />}
          </button>
        </div>

        <div className="sidebar__user-card">
          <FaUserCircle className="sidebar__user-avatar" />
          {!collapsed && (
            <div className="sidebar__user-info">
              <span className="sidebar__user-name">{user?.username || "Guest"}</span>
            </div>
          )}
        </div>

        <nav className="sidebar__nav">
          {!collapsed && (
            <div className="sidebar__section-label">Navigation</div>
          )}
          {visibleLinks.map((item) => {
            const Icon   = item.icon;
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar__link${active ? " sidebar__link--active" : ""}`}
                data-tooltip={item.label}
              >
                <span className="sidebar__icon"><Icon /></span>
                <span className="sidebar__label">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </aside>
      {/* Breadcrumb bar — auto-resolves current route */}
      <Breadcrumb />
    </>
  );
};

export default Sidebar;